import React, { useState, useEffect, useRef } from 'react'
import { SplitButton as PrimeReactSplitButton } from 'primereact/splitbutton'
import { Dropdown } from 'primereact/dropdown'
import './split-button.scss'

export default ({label, primary, onClick, options, disabled, unified}) => {
    const [isOpen, setIsOpen] = useState(false)
    const [isTopPosition, setIsTopPosition] = useState(false)
    const dropdownRef = useRef(null)
    const buttonRef = useRef(null)

    // Toggle dropdown on button click
    const handleButtonClick = () => {
        if (!disabled) {
            setIsOpen(!isOpen)
        }
    }

    // Close dropdown on item click
    const handleItemClick = (item) => {
        item.command?.()
        setIsOpen(false)
    }

    // Close dropdown on outside click and check positioning
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false)
            }
        }

        const checkPosition = () => {
            if (isOpen && buttonRef.current && dropdownRef.current) {
                const buttonRect = buttonRef.current.getBoundingClientRect()
                const panelHeight = 200 // Approximate panel height
                const spaceBelow = window.innerHeight - buttonRect.bottom
                
                // Position on top if not enough space below
                if (spaceBelow < panelHeight && buttonRect.top > panelHeight) {
                    setIsTopPosition(true)
                } else {
                    setIsTopPosition(false)
                }
            }
        }

        if (isOpen) {
            document.addEventListener('mousedown', handleClickOutside)
            checkPosition()
            window.addEventListener('resize', checkPosition)
            window.addEventListener('scroll', checkPosition)
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside)
            window.removeEventListener('resize', checkPosition)
            window.removeEventListener('scroll', checkPosition)
        }
    }, [isOpen])

    // Unified button mode with custom rendering
    if (unified) {
        return (
            <div className="unified-split-button-wrapper ml-3" ref={dropdownRef}>
                <button 
                    ref={buttonRef}
                    className={`unified-split-button ${disabled ? 'disabled' : ''}`}
                    onClick={handleButtonClick}
                    disabled={disabled}
                >
                    <span className="unified-button-label">{label}</span>
                    <span className={`unified-dropdown-arrow ${isOpen ? 'open' : ''}`}>
                        <i className="pi pi-chevron-down"></i>
                    </span>
                </button>
                
                {isOpen && (
                    <div className={`unified-menu-overlay ${isTopPosition ? 'top' : 'bottom'}`}>
                        <ul>
                            {options && options.map((item, idx) => (
                                <li 
                                    key={idx}
                                    className="p-menuitem"
                                    onClick={() => handleItemClick(item)}
                                >
                                    <span className="p-menuitem-link">
                                        {item.label}
                                    </span>
                                </li>
                            ))}
                        </ul>
                    </div>
                )}
            </div>
        )
    }

    // Original PrimeReact mode (default)
    return (
        <PrimeReactSplitButton 
            className={`ml-3 split-btn`}
            label={label} 
            onClick={onClick} 
            model={options}
            disabled={disabled ? true : false}
        />
    )
}